export default __webpack_public_path__ + "static/media/diversity.d463e75f.jpeg";